<div class="import-dialog" [class.has-images]="posts.length > 0">
  <!-- URL Input State -->
  <ng-container *ngIf="!posts.length && !loading">
    <div class="dialog-header">
      <h2>{{ 'Import Products from Social Media' | translate }}</h2>
      <button class="close-btn" mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <p class="dialog-subtitle">
      {{ 'Paste a public link from Instagram, Facebook, or WhatsApp catalog.' | translate }}<br>
      {{ 'We\'ll fetch the images so you can import them as products.' | translate }}
    </p>

    <div class="url-input-container">
      <input
        type="text"
        [(ngModel)]="socialUrl"
        [placeholder]="'Paste your public page or post link here' | translate"
        class="url-input"
      >
    </div>

    <div class="info-box">
      <mat-icon class="info-icon">check_circle</mat-icon>
      <div class="info-text">
        <span class="supported">{{ 'Supported: public Instagram posts/pages, Facebook pages' | translate }}</span>
        <span class="not-supported">{{ 'Not supported: groups, private or closed pages' | translate }}</span>
      </div>
    </div>

    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      {{ error | translate }}
    </div>

    <div class="dialog-actions">
      <button class="cancel-btn" (click)="closeDialog()">{{ 'Cancel' | translate }}</button>
      <button class="fetch-btn" (click)="scrapeImages()" [disabled]="!socialUrl">
        {{ 'Fetch Images' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- Loading State -->
  <ng-container *ngIf="loading">
    <div class="dialog-header">
      <h2>{{ 'Import Products from Social Media' | translate }}</h2>
      <button class="close-btn" mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <p class="dialog-subtitle">
      {{ 'Paste a public link from Instagram, Facebook, or WhatsApp catalog.' | translate }}<br>
      {{ 'We\'ll fetch the images so you can import them as products.' | translate }}
    </p>

    <div class="url-input-container">
      <input
        type="text"
        [(ngModel)]="socialUrl"
        [placeholder]="'Paste your public page or post link here' | translate"
        class="url-input"
        disabled
      >
    </div>

    <div class="info-box">
      <mat-icon class="info-icon">check_circle</mat-icon>
      <div class="info-text">
        <span class="supported">{{ 'Supported: public Instagram posts/pages, Facebook pages' | translate }}</span>
        <span class="not-supported">{{ 'Not supported: groups, private or closed pages' | translate }}</span>
      </div>
    </div>

    <div class="loading-state">
      <div class="loading-spinner"></div>
      <span>{{ 'Fetching images from your link...' | translate }}</span>
    </div>

    <div class="dialog-actions">
      <button class="cancel-btn" (click)="cancelLoading()">{{ 'Cancel' | translate }}</button>
      <button class="fetch-btn" disabled>
        {{ 'Fetch Images' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- Image Selection State -->
  <ng-container *ngIf="posts.length > 0 && !loading">
    <div class="dialog-header">
      <h2>{{ 'Select images to import as products' | translate }}</h2>
      <button class="close-btn" mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <p class="dialog-subtitle">
      {{ 'Paste a public link from Instagram, Facebook, or WhatsApp catalog.' | translate }}<br>
      {{ 'We\'ll fetch the images so you can import them as products.' | translate }}
    </p>

    <div class="selection-header">
      <div class="selection-actions">
        <button class="link-btn" (click)="selectAll()">{{ 'Select All' | translate }}</button>
        <button class="link-btn" (click)="deselectAll()">{{ 'Clear Selection' | translate }}</button>
      </div>
      <span class="selection-count">
        <ng-container *ngIf="maxSelection !== undefined">
          {{ selectedPosts.length }} / {{ maxSelection }} {{ 'can be imported' | translate }}
          <ng-container *ngIf="atLimit"> — <span style="color:#F97316;font-weight:600">{{ 'Limit reached' | translate }}</span></ng-container>
        </ng-container>
        <ng-container *ngIf="maxSelection === undefined">
          {{ selectedPosts.length }} {{ 'Selected' | translate }}
        </ng-container>
      </span>
    </div>

    <div class="images-grid">
      <div
        *ngFor="let post of posts; trackBy: trackByPostId"
        class="image-card"
        [class.selected]="post.selected"
        (click)="togglePostSelection(post)"
      >
        <img [src]="post.imageUrl" [alt]="'Product image' | translate">
        <div class="check-overlay" *ngIf="post.selected">
          <mat-icon>check_circle</mat-icon>
        </div>
      </div>
    </div>

    <div class="load-more-container" *ngIf="hasMoreImages">
      <button class="load-more-btn" (click)="loadMore()" [disabled]="loadingMore">
        <span *ngIf="!loadingMore">{{ 'Load More' | translate }}</span>
        <span *ngIf="loadingMore" class="loading-text">
          <div class="loading-spinner-small"></div>
          {{ 'Loading...' | translate }}
        </span>
      </button>
    </div>

    <p class="import-note">
      {{ 'Selected images will be added as draft products.' | translate }}<br>
      {{ 'You can edit names and prices after importing.' | translate }}
    </p>

    <div class="dialog-actions">
      <button class="cancel-btn" (click)="closeDialog()">{{ 'Cancel' | translate }}</button>
      <button class="import-btn" (click)="importImages()" [disabled]="selectedPosts.length === 0">
        {{ 'Import Images' | translate }}
      </button>
    </div>
  </ng-container>
</div>
